import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';

const Society = () => {
    return (
        <div className="society-page py-5" style={{ paddingTop: '160px !important' }}>
            <Container>
                <Row>
                    <Col lg={12}>
                        {/* Page Header */}
                        <div className="text-center mb-5">
                            <h1 className="display-4 fw-bold text-primary mb-3">
                                Multinational Finance Society
                            </h1>
                            <hr className="mx-auto" style={{ width: '100px', height: '3px' }} />
                        </div>

                        {/* Mission Section */}
                        <Card className="mb-5 shadow-sm">
                            <Card.Header className="bg-primary bg-gradient text-white">
                                <h2 className="h3 mb-0 text-white">
                                    <i className="bi bi-bullseye me-3"></i>
                                    Mission
                                </h2>
                            </Card.Header>
                            <Card.Body className="p-4">
                                <p className="lead mb-4">
                                    The Multinational Finance Society is a non-profit organization established on 
                                    <strong> June 15, 1995</strong> for the advancement and dissemination of financial 
                                    knowledge, philosophies, techniques and research findings pertaining to industrialized 
                                    and developing countries among members of the academic and business communities.
                                </p>
                                
                                <p className="mb-4">
                                    The Society's mission and program are multinational and designed around the key 
                                    functional areas of finance. A shelter of professional nature is, thus, provided 
                                    to academics and practitioners with interests in financial management, theory and 
                                    application. It serves as a central point of meeting, communication and interaction 
                                    for its American, Asian, Australian, European and other international members.
                                </p>
                                
                                <p className="mb-0">
                                    As a means of accomplishing its mission, the Society publishes the 
                                    <strong> Multinational Finance Journal (MFJ)</strong> and organizes conferences 
                                    and special symposia in different international locations.
                                </p>
                            </Card.Body>
                        </Card>

                        {/* Activities Section */}
                        <Card className="mb-5 shadow-sm">
                            <Card.Header className="bg-info bg-gradient text-white">
                                <h2 className="h3 mb-0 text-white">
                                    <i className="bi bi-activity me-3"></i>
                                    Activities
                                </h2>
                            </Card.Header>
                            <Card.Body className="p-4">
                                <Row className="g-4">
                                    {/* Multinational Finance Journal */}
                                    <Col md={6}>
                                        <div className="activity-section">
                                            <h3 className="h4 text-primary mb-3">
                                                <i className="bi bi-journal-text me-2"></i>
                                                Multinational Finance Journal
                                            </h3>
                                            <p className="mb-3">
                                                The MFJ is a leading multinational journal of financial character, 
                                                published quarterly since <strong>1997</strong>. It provides a collection 
                                                of high quality refereed articles, written by scientists of recognized competence.
                                            </p>
                                            <p className="mb-3">
                                                The MFJ publishes articles on capital markets, financial institutions, 
                                                management of investments, and corporate finance, dealing with issues that 
                                                are relevant to the study and practice of finance in a global context.
                                            </p>
                                            <p className="mb-3">
                                                The MFJ makes a unique contribution by publishing research investigating 
                                                phenomena related to the integration and interaction of national financial 
                                                systems at the micro- and macro-finance levels and by disseminating research 
                                                originating from countries with financial markets in different stages of 
                                                development and diverse institutional arrangements.
                                            </p>
                                            <div className="mt-3">
                                                <Link to="/journal" className="btn btn-outline-primary">
                                                    <i className="bi bi-arrow-right me-2"></i>
                                                    For more information (Click Here)
                                                </Link>
                                            </div>
                                        </div>
                                    </Col>

                                    {/* Multinational Finance Conferences */}
                                    <Col md={6}>
                                        <div className="activity-section">
                                            <h3 className="h4 text-success mb-3">
                                                <i className="bi bi-calendar-event me-2"></i>
                                                Multinational Finance Conferences
                                            </h3>
                                            <p className="mb-3">
                                                The Society acknowledges the importance of giving academic researchers, 
                                                educators and practitioners the forum to share, discuss and debate timely 
                                                financial issues, theories, ideas and findings pertaining to industrialized 
                                                and developing countries.
                                            </p>
                                            <p className="mb-3">
                                                The annual conferences and special symposia, organized by the Society in 
                                                various international locations, provide such a forum.
                                            </p>
                                            <div className="mt-3">
                                                <Link to="/conferences" className="btn btn-outline-success">
                                                    <i className="bi bi-arrow-right me-2"></i>
                                                    For more information (Click Here)
                                                </Link>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        {/* Key Highlights */}
                        <Card className="shadow-sm">
                            <Card.Header className="bg-secondary bg-gradient text-white">
                                <h3 className="h4 mb-0 text-white">
                                    <i className="bi bi-star me-3"></i>
                                    Key Highlights
                                </h3>
                            </Card.Header>
                            <Card.Body>
                                <Row className="text-center">
                                    <Col md={3} className="mb-3">
                                        <div className="highlight-item">
                                            <i className="bi bi-calendar3 display-4 text-primary mb-2"></i>
                                            <h5 className="fw-bold">Est. 1995</h5>
                                            <p className="text-muted small">Founded</p>
                                        </div>
                                    </Col>
                                    <Col md={3} className="mb-3">
                                        <div className="highlight-item">
                                            <i className="bi bi-journal-bookmark display-4 text-info mb-2"></i>
                                            <h5 className="fw-bold">Since 1997</h5>
                                            <p className="text-muted small">Publishing MFJ</p>
                                        </div>
                                    </Col>
                                    <Col md={3} className="mb-3">
                                        <div className="highlight-item">
                                            <i className="bi bi-globe display-4 text-success mb-2"></i>
                                            <h5 className="fw-bold">Global</h5>
                                            <p className="text-muted small">Multinational Reach</p>
                                        </div>
                                    </Col>
                                    <Col md={3} className="mb-3">
                                        <div className="highlight-item">
                                            <i className="bi bi-people display-4 text-warning mb-2"></i>
                                            <h5 className="fw-bold">Academic</h5>
                                            <p className="text-muted small">& Business Communities</p>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        {/* Call to Action */}
                        <div className="text-center mt-5">
                            <div className="bg-light p-4 rounded">
                                <h4 className="mb-3">MFS Membership</h4>
                                <p className="mb-3"> The Society’s members are part of an international network of academics and professionals involved in the research, teaching and practice of finance. They are encouraged to attend the Society’s annual conferences and special symposia, held in different international locations. Members are entitled to reduced manuscript submission fees and have free e-access to the Multinational Finance Journal, published quarterly by the Global Business Publications.</p>
                                <p className="mb-3"> The membership fee is €80. For registering to one of our conferences you automatically become a member for one year from the day of registration. </p>
                                <p className="mb-3"> For any questions regarding the membership, please contact us at:mfs@mfsociety.org  </p>
                                
                                <div className="d-flex gap-3 justify-content-center flex-wrap">
                                    <Link to="/register" className="btn btn-primary">
                                        <i className="bi bi-person-plus me-2"></i>
                                        Register
                                    </Link>
                                    <Link to="/login" className="btn btn-outline-primary">
                                        <i className="bi bi-file-earmark-text me-2"></i>
                                        Login
                                    </Link>
                                    {/* <Link to="/dashboard" className="btn btn-outline-secondary">
                                        <i className="bi bi-calendar-event me-2"></i>
                                        View Conferences
                                    </Link> */}
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Society;